import React from "react";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const HistoryRoadMap = ({ timelineData = [], title = '' }) => {
  return (
    <div className="bg-silver-lake-blue max-w-4xl mx-auto p-30">
      <motion.h2
        className="text-3xl font-bold mb-10 text-center text-white"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {title}
      </motion.h2>

      {/* Container for animated timeline items */}
      <motion.div
        className="border-l-2 border-blue-500 pl-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {timelineData.map((itemData) => (
          <motion.div
            key={itemData.key}
            className="mb-20 relative"
            variants={item}
          >
            <div className="absolute -left-[10px] top-1.5 w-4 h-4 bg-blue-500 rounded-full shadow-md" />
            <h4 className="text-xxl font-semibold ">
              {itemData.attributes.title_or_year}
            </h4>
            <ul className="mt-2 space-y-2">
              {itemData.attributes.journey_point.map((point) => (
                <li key={point.key}>
                    <h5 className="font-xl text-white">{point.attributes.title}</h5>
                    {point.attributes.journey_text && (
                        <h6 className="text-sm text-white" >
                            {point.attributes.journey_text}
                        </h6>
                    )}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default HistoryRoadMap;
